function setSelect(theSelect, theValue) {
  for (var i = 0; i < theSelect.options.length; i++)
    if (theSelect.options[i].value == theValue) theSelect.selectedIndex = i;
}

window.setSelect = setSelect;
